import { render } from "./StudentsView.vue?vue&type=template&id=6fd0395d&scoped=true"
import script from "./StudentsView.vue?vue&type=script&lang=js"
export * from "./StudentsView.vue?vue&type=script&lang=js"

import "./StudentsView.vue?vue&type=style&index=0&id=6fd0395d&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fd0395d"]])

export default __exports__